import { render, staticRenderFns } from "./moreAction.vue?vue&type=template&id=e845a034&scoped=true"
import script from "./moreAction.vue?vue&type=script&lang=js"
export * from "./moreAction.vue?vue&type=script&lang=js"
import style0 from "./moreAction.vue?vue&type=style&index=0&id=e845a034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e845a034",
  null
  
)

export default component.exports